<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Movimiento: {{ movimiento.codigo }}</h1>
            <div v-if="movimiento.status === 'anulado'" class="badge badge-danger p-2 mt-2">
              <i class="fas fa-ban mr-1"></i> MOVIMIENTO ANULADO
            </div>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Movimiento</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <!-- Cabecera: datos generales (siempre deshabilitados) -->
            <div class="card-header">
              <div class="row">
                <div class="col-md-2">
                  <label>Tipo</label>
                  <input class="form-control text-uppercase" v-model="this.tipo" disabled />
                </div>
                <div class="col-md-2">
                  <label>No. Control</label>
                  <input class="form-control" v-model="movimiento.numcontrol" disabled />
                </div>
                <div class="col-md-2" v-if="movimiento.venta">
                  <label>Venta Asociada</label>
                  <input class="form-control font-weight-bold" :value="movimiento.venta?.numcontrol" disabled />
                </div>
                <div class="col-md-2">
                  <label>Fecha</label>
                  <input class="form-control" v-model="movimiento.fecha" type="date" disabled />
                </div>
                <div class="col-md-4">
                  <label>Motivo</label>
                  <input class="form-control text-uppercase" v-model="movimiento.motivo.nombre" disabled />
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-4">
                  <label>Responsable</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-user-check"></i></span>
                    </div>
                    <input class="form-control font-weight-bold text-uppercase" v-model="movimiento.responsable" disabled />
                  </div>
                </div>
                <div class="col-md-4" v-if="movimiento.origen && movimiento.origen.descripcion">
                  <label>Almacén Origen</label>
                  <input class="form-control" v-model="movimiento.origen.descripcion" disabled />
                </div>
                <div class="col-md-4" v-if="movimiento.destino && movimiento.destino.descripcion">
                  <label>Almacén Destino</label>
                  <input class="form-control" v-model="movimiento.destino.descripcion" disabled />
                </div>
              </div>
              <div class="row mt-3" v-if="movimiento.observ">
                <div class="col-12">
                  <label>Observaciones Generales</label>
                  <textarea class="form-control" v-model="movimiento.observ" disabled rows="2"></textarea>
                </div>
              </div>
            </div>
            <!-- /.card-header -->

            <!-- Soporte Documental -->
            <div class="card-body border-top p-3">
              <div class="row">
                <!-- Documento de Respaldo -->
                <div :class="movimiento.status === 'anulado' && movimiento.acta_anulacion ? 'col-md-6' : 'col-12'">
                  <div v-if="movimiento.evidencia" class="card border-info collapsed-card h-100 mb-0">
                    <div class="card-header bg-info text-white">
                      <h3 class="card-title"><i class="fas fa-paperclip mr-2"></i>Documento de Respaldo</h3>
                      <div class="card-tools">
                        <button type="button" class="btn btn-tool text-white" data-card-widget="collapse"><i class="fas fa-plus"></i></button>
                      </div>
                    </div>
                    <div class="card-body d-flex align-items-center justify-content-between" style="display: none;">
                      <div>
                        <strong>Archivo:</strong> {{ movimiento.evidencia.nombre }}
                        <br>
                        <small class="text-muted">Tipo: {{ movimiento.evidencia.tipo }}</small>
                      </div>
                      <div>
                        <a :href="movimiento.evidencia.url" target="_blank" rel="noopener noreferrer" class="btn btn-primary">
                          <i class="fas fa-file-pdf mr-2"></i> Ver
                        </a>
                        <a :href="movimiento.evidencia.url" :download="movimiento.evidencia.nombre" class="btn btn-outline-secondary ml-2">
                          <i class="fas fa-download"></i>
                        </a>
                      </div>
                    </div>
                    <div v-if="movimiento.evidencia?.tipo?.includes('image')" class="card-footer text-center bg-light">
                      <h6>Vista Previa:</h6>
                      <img :src="movimiento.evidencia.url" alt="Evidencia" class="img-fluid rounded shadow-sm"
                        style="max-height: 200px; border: 1px solid #dee2e6; cursor: pointer;"
                        @click="abrirEvidencia(movimiento.evidencia.url)">
                    </div>
                  </div>
                  <div v-else class="alert alert-warning mb-0">
                    <i class="fas fa-exclamation-triangle mr-2"></i> Sin documentos de evidencia.
                  </div>
                </div>

                <!-- Acta de Anulación (si aplica) -->
                <div v-if="movimiento.status === 'anulado' && movimiento.acta_anulacion" class="col-md-6">
                  <div class="card border-danger collapsed-card h-100 mb-0">
                    <div class="card-header bg-danger text-white">
                      <h3 class="card-title"><i class="fas fa-file-signature mr-2"></i>Acta de Anulación</h3>
                      <div class="card-tools">
                        <button type="button" class="btn btn-tool text-white" data-card-widget="collapse"><i class="fas fa-plus"></i></button>
                      </div>
                    </div>
                    <div class="card-body d-flex align-items-center justify-content-between" style="display: none;">
                      <div>
                        <strong>Archivo:</strong> {{ movimiento.acta_anulacion.nombre }}
                        <br>
                        <small class="text-muted">Tipo: {{ movimiento.acta_anulacion.tipo }}</small>
                      </div>
                      <div>
                        <a :href="movimiento.acta_anulacion.url" target="_blank" rel="noopener noreferrer" class="btn btn-danger">
                          <i class="fas fa-file-pdf mr-2"></i> Ver
                        </a>
                      </div>
                    </div>
                    <div v-if="movimiento.acta_anulacion?.tipo?.includes('image')" class="card-footer text-center bg-light">
                      <h6>Vista Previa Acta:</h6>
                      <img :src="movimiento.acta_anulacion.url" alt="Acta Anulación" class="img-fluid rounded shadow-sm"
                        style="max-height: 200px; border: 1px solid #dc3545; cursor: pointer;"
                        @click="abrirEvidencia(movimiento.acta_anulacion.url)">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cuerpo: detalles del movimiento -->
            <div class="card-body table-responsive p-0">
              <table class="table table-bordered table-striped mb-0">
                <thead>
                  <tr>
                    <th style="width: 15%;">Código</th>
                    <th>Descripción</th>
                    <th style="width: 15%;">Cantidad</th>
                    <th style="width: 10%;">U/M</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in movimiento.detalles" :key="item.producto.id">
                    <tr v-if="Math.floor(item.cantidad / item.producto.cantxcaja) > 0">
                      <td>{{ item.producto.codigo }}</td>
                      <td>{{ item.producto.descripcion }}</td>
                      <td class="font-weight-bold">{{ Math.floor(item.cantidad / item.producto.cantxcaja) }}</td>
                      <td>CJ</td>
                    </tr>
                    <tr v-if="(item.cantidad % item.producto.cantxcaja) > 0 || item.cantidad === 0">
                      <td>{{ item.producto.codigo }}</td>
                      <td>{{ item.producto.descripcion }}</td>
                      <td class="font-weight-bold">{{ item.cantidad % item.producto.cantxcaja }}</td>
                      <td>UN</td>
                    </tr>
                  </template>
                  <tr v-if="!movimiento.detalles.length">
                    <td colspan="4" class="text-center">
                      No hay detalles para este movimiento.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->

            <div class="card-footer d-flex align-items-center justify-content-between">
              <button
                class="btn btn-info"
                @click="generarReportePDF"
                :disabled="loading || !movimiento.pdf_reporte"
                :title="!movimiento.pdf_reporte ? 'PDF no disponible' : 'Descargar Nota'"
              >
                <i class="fas fa-file-pdf mr-1"></i> {{ !movimiento.pdf_reporte ? 'Sin Reporte' : 'Descargar Nota' }}
              </button>

              <div class="ml-auto">
                <button v-if="movimiento.status !== 'anulado'" class="btn btn-danger" @click="modalAnulacion" :disabled="loading">
                  <i class="fas fa-ban mr-1"></i> Anular Movimiento
                </button>
                <div v-else class="alert alert-danger mb-0 py-1 px-3">
                  <i class="fas fa-info-circle mr-1"></i>
                  <strong>MOVIMIENTO ANULADO:</strong> {{ movimiento.motivo_anulacion }}
                </div>
              </div>
            </div>
            <!-- /.card-footer -->
          </div>
          <!-- /.card -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api'
import Swal from 'sweetalert2'

export default {
  name: 'MovimientoDetalle',
  props: ['tipo', 'numcontrol'],
  data() {
    return {
      movimiento: {
        codigo: '',
        tipo: '',
        numcontrol: '',
        fecha: '',
        responsable: '',
        observ: '',
        venta_codigo: null,
        motivo: {},
        origen: {},
        destino: {},
        detalles: [],
        venta: [],
        status: '',
        acta_anulacion: null,
      },
      loading: false,
      error: null,
    }
  },
  methods: {
    async fetchMovimiento() {
      this.loading = true
      try {
        const { data } = await api.get(`/${this.tipo}s/batch/${this.numcontrol}`)
        this.movimiento = data
        console.log('Movimiento cargado:', this.movimiento)
      } catch (err) {
        Swal.fire('Error', 'No se pudo cargar el detalle', 'error')
      } finally {
        this.loading = false
      }
    },
    async modalAnulacion() {
      const { value: formValues } = await Swal.fire({
        title: 'Anular Movimiento',
        icon: 'warning',
        html: `
          <div class="text-left">
            <label>Motivo de la anulación (mín. 10 caracteres):</label>
            <textarea id="motivo-anul" class="form-control mb-3" rows="3"></textarea>
            <label>Adjuntar Acta de Anulación (PDF/Imagen):</label>
            <input type="file" id="archivo-anul" class="form-control" accept=".pdf,.jpg,.jpeg,.png">
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Confirmar Anulación',
        confirmButtonColor: '#d33',
        preConfirm: () => {
          const motivo = document.getElementById('motivo-anul').value
          const archivo = document.getElementById('archivo-anul').files[0]
          if (!motivo || motivo.length < 10) {
            Swal.showValidationMessage('Escribe un motivo válido (mín. 10 carac.)')
            return false
          }
          if (!archivo) {
            Swal.showValidationMessage('Debes adjuntar el acta de respaldo')
            return false
          }
          return { motivo, archivo }
        }
      })
      if (formValues) {
        this.procesarAnulacion(formValues)
      }
    },
    async procesarAnulacion({ motivo, archivo }) {
      this.loading = true
      const formData = new FormData()
      formData.append('motivo_anulacion', motivo)
      formData.append('acta_anulacion', archivo)
      try {
        await api.post(`/${this.tipo}s/batch/${this.numcontrol}/anular`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        Swal.fire('¡Anulado!', 'El stock ha sido revertido correctamente.', 'success')
        this.fetchMovimiento()
      } catch (err) {
        Swal.fire('Error', err.response?.data?.message || 'Error al anular', 'error')
      } finally {
        this.loading = false
      }
    },
    generarReportePDF() {
      // Verificamos si la URL existe en el objeto cargado
      if (this.movimiento.pdf_reporte) {
        // Abrir en una pestaña nueva para visualizar
        window.open(this.movimiento.pdf_reporte, '_blank');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Reporte no disponible',
          text: 'No se encontró un archivo PDF vinculado a este movimiento.',
          confirmButtonText: 'Entendido'
        });
      }
    },
    formatCJyUN(item) {
      const { cantxcaja } = item.producto
      const cajas = Math.floor(item.cantidad / cantxcaja)
      const unidades = item.cantidad % cantxcaja
      if (cajas && unidades) return `${cajas}CJ + ${unidades}UN`
      if (cajas) return `${cajas}CJ`
      return `${unidades}UN`
    }
  },
  created() {
    this.fetchMovimiento()
  }
}
</script>